import Vue from 'vue';
import App from './App.vue';
import AOS from 'aos';
import 'aos/dist/aos.css';
import smoothScroll from 'vue-smooth-scroll'

Vue.config.productionTip = false;
Vue.use(smoothScroll);

new Vue({
  created () {
    AOS.init();
  },
  render: (h) => h(App),
}).$mount('#app');
